import * as main from '../../constants/main'

export const redirect = url => {
    return {
        type: main.MAIN_REDIRECT,
        payload: url
    }
}